import { render, staticRenderFns } from "./PlatformNavigation.vue?vue&type=template&id=7e8ad176&scoped=true&"
import script from "./PlatformNavigation.vue?vue&type=script&lang=js&"
export * from "./PlatformNavigation.vue?vue&type=script&lang=js&"
import style0 from "./PlatformNavigation.vue?vue&type=style&index=0&id=7e8ad176&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8ad176",
  null
  
)

export default component.exports